module.exports = __webpack_public_path__ + "img/lotnisko.bc8e8fdb.jpg";